import languages from 'localization/languages.json'

export default class LanguageService {
  static getLanguages() {
    return Promise.resolve(languages.lang)
  }
}
